import { Injector, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LeftNavComponent } from './left-nav.component';
import { DxTreeViewModule } from 'devextreme-angular/ui/tree-view';
import { DxTemplateModule } from 'devextreme-angular';
import { createCustomElement } from '@angular/elements';
import { Router, RouterModule, Routes } from '@angular/router';

const routes: Routes = []


@NgModule({
  declarations: [LeftNavComponent],
  imports: [
    CommonModule,
    RouterModule.forRoot(routes),
    DxTreeViewModule,
    DxTemplateModule
  ],
  entryComponents: [LeftNavComponent],
  exports: [LeftNavComponent]
})
export class LeftNavModule {
  constructor(private router: Router, private injector: Injector) { }

ngDoBootstrap() {
  const custom = createCustomElement(LeftNavComponent, { injector: this.injector });
  customElements.define('crem-nav', custom);
}

}
